// src/components/Navbar.js
// Slim public website nav with hidden operational access for authorised users.

import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  FaBars,
  FaHome,
  FaImages,
  FaInfoCircle,
  FaShieldAlt,
  FaSignInAlt,
  FaTimes,
  FaUserPlus,
  FaUserShield,
} from "react-icons/fa";

import "../styles/Navbar.css";
import { ROUTES } from "../config";

const Navbar = ({ userRole, onLogout }) => {
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLinkClick = () => setMenuOpen(false);

  return (
    <nav className="navbar">
      <div className="navbar-inner container">
        <Link to={ROUTES.HOME} className="nav-logo" onClick={handleLinkClick}>
          GhrianGhraffy
        </Link>

        <button
          className="nav-toggle"
          type="button"
          aria-label="Toggle navigation"
          onClick={() => setMenuOpen((prev) => !prev)}
        >
          {menuOpen ? <FaTimes /> : <FaBars />}
        </button>

        <ul className={`nav-links ${menuOpen ? "nav-links--open" : ""}`}>
          <li className="nav-item">
            <Link to={ROUTES.HOME} className="nav-link" onClick={handleLinkClick}>
              <FaHome className="nav-icon" />
              <span>Home</span>
            </Link>
          </li>

          {!userRole && (
            <>
              <li className="nav-item">
                <Link
                  to={ROUTES.PRINCIPAL_REGISTRATION}
                  className="nav-link nav-link--cta"
                  onClick={handleLinkClick}
                >
                  <FaUserPlus className="nav-icon" />
                  <span>Register as Principal</span>
                </Link>
              </li>

              <li className="nav-item">
                <Link to={ROUTES.LOGIN} className="nav-link" onClick={handleLinkClick}>
                  <FaSignInAlt className="nav-icon" />
                  <span>Login</span>
                </Link>
              </li>

              <li className="nav-item">
                <Link to={ROUTES.PRIVACY} className="nav-link" onClick={handleLinkClick}>
                  <FaShieldAlt className="nav-icon" />
                  <span>Privacy</span>
                </Link>
              </li>

              <li className="nav-item">
                <Link to={ROUTES.FAQ} className="nav-link" onClick={handleLinkClick}>
                  <FaInfoCircle className="nav-icon" />
                  <span>FAQ</span>
                </Link>
              </li>
            </>
          )}

          {userRole && userRole !== "ADMIN" && (
            <li className="nav-item">
              <Link to={ROUTES.VIEW_PHOTOS} className="nav-link" onClick={handleLinkClick}>
                <FaImages className="nav-icon" />
                <span>View Photos</span>
              </Link>
            </li>
          )}

          {userRole === "ADMIN" && (
            <li className="nav-item">
              <Link to={ROUTES.ADMIN} className="nav-link" onClick={handleLinkClick}>
                <FaUserShield className="nav-icon" />
                <span>Admin</span>
              </Link>
            </li>
          )}

          {userRole && (
            <li className="nav-item nav-item--logout">
              <button
                className="nav-link nav-link--ghost"
                type="button"
                onClick={() => {
                  onLogout();
                  handleLinkClick();
                }}
              >
                <FaSignInAlt className="nav-icon" />
                <span>Logout</span>
              </button>
            </li>
          )}
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
